export class Coordinates {
    x: number;
    y: number;
    alignCenter: boolean;
}



// WEBPACK FOOTER //
// /Users/mac/PlayGround/src/app/shared/coordinates.model.ts